import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { buildBackendGoRedirectUrl } from '../utils/affiliateLinks';

const PublicGoRedirectPage = () => {
  const { slug } = useParams();
  const [error, setError] = useState('');
  const target = useMemo(() => buildBackendGoRedirectUrl(slug), [slug]);

  useEffect(() => {
    if (!target || target === '#') {
      setError('Invalid tool link. Please return and try again.');
      return;
    }
    window.location.replace(target);
  }, [target]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: 'var(--bg-base)', color: 'var(--text-primary)' }}>
      <div className="text-center">
        <h1 className="text-2xl font-semibold mb-3">Redirecting you to the partner page…</h1>
        <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
          If you are not redirected automatically, use the direct link below.
        </p>
        {target && target !== '#' ? (
          <a
            href={target}
            className="inline-flex mt-3 px-4 py-2 border rounded-lg text-sm"
            style={{ borderColor: 'var(--border-subtle)', color: 'var(--text-primary)' }}
            rel="sponsored nofollow noopener noreferrer"
          >
            Continue to partner site
          </a>
        ) : null}
        {error ? <p className="mt-3 text-sm text-red-400">{error}</p> : null}
      </div>
    </div>
  );
};

export default PublicGoRedirectPage;
